/**
 * Message Bubble Component
 *
 * Displays a single message in the chat area.
 * Different styling for own messages vs received messages.
 */

import React from "react";
import { MessageBubbleProps } from "./types";

export const MessageBubble: React.FC<MessageBubbleProps> = ({ message, senderAvatar }) => (
  <div className={`flex ${message.isOwn ? "justify-end" : "justify-start"} mb-3`}>
    {!message.isOwn && senderAvatar && (
      <img src={senderAvatar} alt="" className="w-8 h-8 rounded-full mr-2 self-end" />
    )}
    <div
      className={`max-w-[70%] px-4 py-2.5 rounded-2xl ${
        message.isOwn
          ? "bg-[#1C6E46] text-white rounded-br-md"
          : "bg-slate-100 dark:bg-gray-700 text-slate-800 dark:text-gray-100 rounded-bl-md"
      }`}
    >
      <p className="text-sm leading-relaxed">{message.content}</p>
      <div className={`flex items-center justify-end gap-1 mt-1 ${message.isOwn ? "text-white/70" : "text-slate-400 dark:text-gray-400"}`}>
        <span className="text-[10px]">{message.timestamp}</span>
        {message.isOwn && (
          <span className="text-[10px]">
            {message.status === "read" ? "✓✓" : message.status === "delivered" ? "✓✓" : "✓"}
          </span>
        )}
      </div>
    </div>
  </div>
);
